// extracted by mini-css-extract-plugin
export default {"calendarBottomText":"Calendar_calendarBottomText__eSq8r","calendarHeader":"Calendar_calendarHeader__93jJ1"};